import React from "react";
import { Link } from "react-router-dom";
import {
  Mail,
  Phone,
  MapPin,
  Facebook,
  Instagram,
  Linkedin,
  Youtube,
} from "lucide-react";

import { Logo } from "./Header";

/* -------------------------------------------------------------------------- */
/*                                Footer Links                                */
/* -------------------------------------------------------------------------- */

const COMPANY_LINKS = [
  { label: "About Us", to: "/about" },
  { label: "Contact", to: "/contact" },
  { label: "Blog", to: "/blog" },
  { label: "Success Stories", to: "/success-stories" },
];

const STUDENT_LINKS = [
  { label: "Courses", to: "/courses" },
  { label: "Jobs", to: "/jobs" },
  { label: "Mock Interviews", to: "/mock-interviews" },
  { label: "Students", to: "/students" },
];

const COMPANY_SERVICES = [
  { label: "Hire Talent", to: "/companies" },
  { label: "Campus Hiring", to: "/colleges" },
  { label: "Corporate Training", to: "/companies" },
];

const SOCIAL_LINKS = [
  {
    icon: <Linkedin size={18} />,
    href: "#",
  },
  {
    icon: <Instagram size={18} />,
    href: "#",
  },
  {
    icon: <Facebook size={18} />,
    href: "#",
  },
  {
    icon: <Youtube size={18} />,
    href: "#",
  },
];

export default function Footer() {
  return (
    <footer className="bg-[#06252C] text-white">

      {/* Top Section */}

      <div className="mx-auto max-w-7xl px-6 py-16">

        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-5">

          {/* Company Info */}

          <div className="lg:col-span-2">

            <Logo />

            <p className="mt-6 max-w-md text-sm leading-7 text-white/75">
              SkillEn bridges the gap between education and employment through
              industry-focused training, career guidance, placement support,
              and hiring solutions for companies and institutions.
            </p>

            <div className="mt-8 space-y-4">

              <div className="flex items-start gap-3">
                <MapPin
                  size={18}
                  className="mt-1 text-[#F26C21]"
                />

                <span className="text-sm text-white/80">
                  Bengaluru, Karnataka, India
                </span>
              </div>

              <div className="flex items-center gap-3">
                <Phone
                  size={18}
                  className="text-[#F26C21]"
                />

                <span className="text-sm text-white/80">
                  +91 XXXXX XXXXX
                </span>
              </div>

              <div className="flex items-center gap-3">
                <Mail
                  size={18}
                  className="text-[#F26C21]"
                />

                <span className="text-sm text-white/80">
                  hello@skillen.in
                </span>
              </div>

            </div>

          </div>

          {/* Company Links */}

          <div>

            <h3 className="mb-5 text-lg font-semibold">
              Company
            </h3>

            <ul className="space-y-3">

              {COMPANY_LINKS.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-white/75 transition hover:text-[#F26C21]"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}

            </ul>

          </div>

          {/* Student Links */}

          <div>

            <h3 className="mb-5 text-lg font-semibold">
              Students
            </h3>

            <ul className="space-y-3">

              {STUDENT_LINKS.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-white/75 transition hover:text-[#F26C21]"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}

            </ul>

          </div>

          {/* Company Services */}

          <div>

            <h3 className="mb-5 text-lg font-semibold">
              Employers
            </h3>

            <ul className="space-y-3">

              {COMPANY_SERVICES.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-white/75 transition hover:text-[#F26C21]"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}

            </ul>

          </div>

        </div>
		          {/* Bottom Section */}

          <div className="mt-16 flex flex-col items-center justify-between gap-8 border-t border-white/10 pt-8 md:flex-row">

            {/* Copyright */}

            <div className="text-center text-sm text-white/60 md:text-left">
              © {new Date().getFullYear()} SkillEn. All rights reserved.
            </div>

            {/* Social Icons */}

            <div className="flex items-center gap-4">

              {SOCIAL_LINKS.map((item, index) => (
                <a
                  key={index}
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex h-10 w-10 items-center justify-center rounded-full border border-white/10 bg-white/5 text-white transition-all duration-300 hover:border-[#F26C21] hover:bg-[#F26C21] hover:text-white"
                >
                  {item.icon}
                </a>
              ))}

            </div>

            {/* Legal Links */}

            <div className="flex items-center gap-6 text-sm">

              <Link
                to="/privacy-policy"
                className="text-white/60 transition hover:text-[#F26C21]"
              >
                Privacy Policy
              </Link>

              <Link
                to="/terms"
                className="text-white/60 transition hover:text-[#F26C21]"
              >
                Terms & Conditions
              </Link>

            </div>

          </div>

      </div>

    </footer>
  );
}